"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrivingLicenceLookupValidation = void 0;
const journey_services_1 = require("@athena-portal/journey-services");
class DrivingLicenceLookupValidation extends journey_services_1.ValidationMethodBase {
    constructor(props) {
        super();
        this.props = props;
        if (!this.props.interactionField) {
            throw Error("DrivingLicenceLookupValidation missing interactionField attribute");
        }
        if (!this.props.failedLookupErrorMessage) {
            throw Error("DrivingLicenceLookupValidation missing failedLookupErrorMessage attribute");
        }
    }
    validateInput(input, context) {
        const pageContext = context;
        if (pageContext.engine) {
            const interaction = pageContext.engine.getInteraction();
            const uiState = journey_services_1.ObjectManipulator.fetchFieldValue("uistate", interaction);
            if (!(uiState === null || uiState === void 0 ? void 0 : uiState.hasDlnOnLoad) && !uiState.backPressed) {
                const dlnLookupData = journey_services_1.ObjectManipulator.fetchFieldValue(this.props.interactionField, interaction);
                if (dlnLookupData && (!dlnLookupData.dlnLookupCallSucess || dlnLookupData.dlnLookupResponseHasError)) {
                    return this.invalidResult(journey_services_1.ExpressionEvaluator.renderTemplate(this.props.failedLookupErrorMessage, interaction));
                }
            }
        }
        return this.validResult();
    }
}
exports.DrivingLicenceLookupValidation = DrivingLicenceLookupValidation;
//# sourceMappingURL=DrivingLicenceLookupValidation.js.map